<template>
    <div v-if="visible" class="popup-overlay">
        <div class="popup">
            <div class="popup-header">
                <!--<img src="@/assets/fisi.jpg" alt="FIST Logo" class="logo" />-->
            </div>

            <div class="popup-content">
                <!--<h3>Validez la date du jour :</h3>-->
                <!--<p class="date">{{ dateAujourdhui }}</p>-->

                <div class="instruction">
                    <img src="@/images/cartes_cps.jpg" alt="CPS Cards" class="cps-image" />
                    <h3 class="text">
                        Entrez le code porteur de votre Carte de Professionnel de Santé
                    </h3>
                </div>
                    <input type="password"
                           v-model="code"
                           maxlength="4"
                           inputmode="numeric"
                           autocomplete="one-time-code"
                           data-testid="code-porteur-cps"
                           class="input"
                           @input="onCodeInput" />

                <div v-if="ErreurCodeCPS" class="error-message">
                    ❌ Code incorrect. Tentatives restantes : {{ nbTentative }}
                </div>
            </div>

            <div class="popup-buttons">
                <!--<button class="btn quit" @click="quitter">Quitter TransCAM</button>-->
                <button class="btn ok" type="button" data-testid="code-porteur-cps-ok" @click="valider" :disabled="code.length !== 4">OK</button>
                <button class="btn cancel" @click="annuler">Annuler</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { defineComponent } from "vue";
    import { mapGetters, mapMutations } from "vuex";
import RequestManager from "../../script/request";

    export default defineComponent({
        name: "PopupCodeCPS",

        props: {
            visible: {
                type: Boolean,
                default: true,
            },
            onClose: {
                type: Function,
                required: false,
            },
            onValidate: {
                type: Function,
                required: false,
            },
        },

        data() {
            return {
                code: "",
                dateAujourdhui: new Date().toLocaleDateString("fr-FR", {
                    weekday: "long",
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                }),
            };
        },

        computed: {
            ...mapGetters("Cartes", ["getErreurCodeCPS", "getNbTentativeDuCodeCPS"]),
            ErreurCodeCPS() {
                return this.getErreurCodeCPS;
            },
            nbTentative() {
                return this.getNbTentativeDuCodeCPS;
            },
        },

        methods: {
            getCode() {
                return "SALUT";
            },
            ...mapMutations("LectureCPS", [
                "setErreurCodeCPS",
                "decrementerNbTentativeDuCodeCPS",
            ]),

            /** CTT 1.40.14 § 1.01 — code porteur CPS : numérique uniquement, 4 positions max. */
            onCodeInput() {
                this.code = this.code.replace(/\D/g, '').slice(0, 4);
            },

            quitter() {
                //alert("TransCAM fermé");
                //if (typeof this.onClose === "function") {
                //    this.onClose();
                //}
                this.$store.dispatch('ConnexionStore/deconnexion');
            },

            valider() {
                //const codeCorrect = "1234"; // À remplacer par un appel réel à une API ou une logique métier
                RequestManager.EnvoyerMessageWebView({ action: "LireCartePS", parameters: [this.code, "RelectureCarte"] });
                // Le PIN est utilise de facon transitoire : on ne le conserve pas.
                this.code = '';
                //alert("On valide !!!");
                //if (this.code === codeCorrect) {
                //    this.setErreurCodeCPS(false);
                //    if (typeof this.onValidate === "function") {
                //        this.onValidate(this.code);
                //    }
                //} else {
                //    this.setErreurCodeCPS(true);
                //    this.decrementerNbTentativeDuCodeCPS();
                //}
            },

            annuler() {
                this.code = "";
                this.setErreurCodeCPS(false); // Réinitialise l'erreur si on annule
                if (typeof this.onClose === "function") {
                    this.onClose();
                }
            },
        },
        watch: {
            getErreurCodeCPS(newVal, oldVal){

            }
        }
    });
</script>

<style scoped>
    .popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9998;
    }

    .popup {
        width: 380px;
        max-width: calc(100vw - 32px);
        box-sizing: border-box;
        border: 1px solid #aaa;
        background: white;
        font-family: 'Segoe UI', sans-serif;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        padding: 16px;
        border-radius: 8px;
        z-index: 9999;
    }

    .popup-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .logo {
        width: 80px;
    }

    .popup-content {
        margin-top: 10px;
    }

    .date {
        font-weight: bold;
        color: #1a0088;
        font-size: 1.2rem;
        margin: 10px 0;
    }

    .instruction {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 15px;
    }

    .cps-image {
        width: 80px;
    }

    .text {
        font-size: 0.9rem;
        flex: 1;
    }

    .input {
        width: 100%;
        margin-top: 5px;
        padding: 5px;
        font-size: 1rem;
        border: 2px solid #1a0088;
        border-radius: 4px;
        outline: none;
    }

        .input:focus {
            border-color: #007bff;
            box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
        }

    .popup-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .btn {
        padding: 5px 10px;
        border: none;
        cursor: pointer;
    }

    .quit {
        background-color: #eee;
    }

    .ok {
        background-color: #cce5ff;
    }

    .cancel {
        background-color: #f5f5f5;
    }

    .error-message {
        color: red;
        font-weight: bold;
        margin-top: 10px;
    }

    /* Mobile : popup positionnee dans le tiers superieur (pas collee au bord haut)
       pour rester visible quand le clavier virtuel s'ouvre, au lieu d'etre centree
       verticalement donc masquee par le clavier. Le defilement reste possible. */
    @media (max-width: 600px) {
        .popup-overlay {
            align-items: flex-start;
            padding: 16px;
            overflow-y: auto;
        }

        .popup {
            width: 100%;
            max-width: 420px;
            margin-top: 12vh;
            margin-bottom: 24px;
        }
    }
</style>
